import { render, staticRenderFns } from "./CraftGantt.vue?vue&type=template&id=3bcdbbe0&scoped=true"
import script from "./CraftGantt.vue?vue&type=script&lang=js"
export * from "./CraftGantt.vue?vue&type=script&lang=js"
import style0 from "./CraftGantt.vue?vue&type=style&index=0&id=3bcdbbe0&prod&lang=scss"
import style1 from "./CraftGantt.vue?vue&type=style&index=1&id=3bcdbbe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcdbbe0",
  null
  
)

export default component.exports